/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "../adminShared";
import { PlacementEditor } from "../PlacementEditor";
import { VotingColumnEditor } from "../VotingColumnEditor";

export const ColorsSection = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, bgVideoBlur, setBgVideoBlur, bgVideoBrightness, setBgVideoBrightness, bgVideoOpacity, setBgVideoOpacity, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, rowBgEvenTranslucent, setRowBgEvenTranslucent, rowBgOddTranslucent, setRowBgOddTranslucent, rowBadgeTranslucent, setRowBadgeTranslucent, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, positionBadgeTranslucent, setPositionBadgeTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, mysteryHiddenPoints, setMysteryHiddenPoints, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    fontTitleItalic, setFontTitleItalic, fontSubtitleItalic, setFontSubtitleItalic, fontCountryItalic, setFontCountryItalic,
    fontPointsItalic, setFontPointsItalic, fontVotingItalic, setFontVotingItalic, fontVotingSecondaryItalic, setFontVotingSecondaryItalic,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12ShowConfetti, setOverlay12ShowConfetti, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  // Convert a hex/rgba color string into a #rrggbb value usable by <input type="color">.
  const toPickerHex = (c) => {
    if (!c || typeof c !== 'string') return "#000000";
    if (c.startsWith('#')) return c.slice(0, 7).padEnd(7, '0');
    const m = c.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map((s) => parseInt(s.trim(), 10));
      const h = (n) => Math.max(0, Math.min(255, isNaN(n) ? 0 : n)).toString(16).padStart(2, '0');
      return `#${h(parts[0])}${h(parts[1])}${h(parts[2])}`;
    }
    return "#000000";
  };
  return (
    <>
                {/* Colores del Tema */}
                <div className="grid md:grid-cols-3 gap-4">
                  <div>
                    <Label htmlFor="primary-color" className="text-zinc-300 mb-2 block font-semibold">Color Primario</Label>
                    <div className="flex gap-2">
                      <input
                        type="color"
                        id="primary-color"
                        data-testid="input-primary-color"
                        value={primaryColor}
                        onChange={(e) => setPrimaryColor(e.target.value)}
                        className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                      />
                      <Input
                        value={primaryColor}
                        onChange={(e) => setPrimaryColor(e.target.value)}
                        className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                        placeholder="#EC4899"
                      />
                    </div>
                    <p className="text-zinc-500 text-xs mt-1">Puntos y acentos principales</p>
                  </div>
                  
                  <div>
                    <Label htmlFor="secondary-color" className="text-zinc-300 mb-2 block font-semibold">Color Secundario</Label>
                    <div className="flex gap-2">
                      <input
                        type="color"
                        id="secondary-color"
                        data-testid="input-secondary-color"
                        value={secondaryColor}
                        onChange={(e) => setSecondaryColor(e.target.value)}
                        className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                      />
                      <Input
                        value={secondaryColor}
                        onChange={(e) => setSecondaryColor(e.target.value)}
                        className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                        placeholder="#22D3EE"
                      />
                    </div>
                    <p className="text-zinc-500 text-xs mt-1">12 puntos ocultos (???)</p>
                  </div>

                  <div>
                    <Label htmlFor="tertiary-color" className="text-zinc-300 mb-2 block font-semibold">Color Terciario</Label>
                    <div className="flex gap-2">
                      <input
                        type="color"
                        id="tertiary-color"
                        data-testid="input-tertiary-color"
                        value={tertiaryColor}
                        onChange={(e) => setTertiaryColor(e.target.value)}
                        className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                      />
                      <Input
                        value={tertiaryColor}
                        onChange={(e) => setTertiaryColor(e.target.value)}
                        className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                        placeholder="#8B5CF6"
                      />
                    </div>
                    <p className="text-zinc-500 text-xs mt-1">Gradientes y complementos</p>
                  </div>
                </div>

                {/* Tamaños de Fuente */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Tamaño de Fuentes</Label>
                  <p className="text-zinc-500 text-sm mb-4">Ajusta el tamaño de cada elemento en píxeles</p>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="font-size-title" className="text-zinc-300 mb-2 block">Título Principal ({fontSizeTitle}px)</Label>
                      <input
                        type="range"
                        id="font-size-title"
                        data-testid="slider-font-size-title"
                        min="24"
                        max="96"
                        value={fontSizeTitle}
                        onChange={(e) => setFontSizeTitle(Number(e.target.value))}
                        className="w-full h-2 bg-zinc-700 rounded-lg appearance-none cursor-pointer accent-pink-500"
                      />
                    </div>
                    <div>
                      <Label htmlFor="font-size-subtitle" className="text-zinc-300 mb-2 block">Subtítulo ({fontSizeSubtitle}px)</Label>
                      <input
                        type="range"
                        id="font-size-subtitle"
                        data-testid="slider-font-size-subtitle"
                        min="10"
                        max="32"
                        value={fontSizeSubtitle}
                        onChange={(e) => setFontSizeSubtitle(Number(e.target.value))}
                        className="w-full h-2 bg-zinc-700 rounded-lg appearance-none cursor-pointer accent-pink-500"
                      />
                    </div>
                    <div>
                      <Label htmlFor="font-size-country" className="text-zinc-300 mb-2 block">Nombres de Países ({fontSizeCountry}px)</Label>
                      <input
                        type="range"
                        id="font-size-country"
                        data-testid="slider-font-size-country"
                        min="10"
                        max="32"
                        value={fontSizeCountry}
                        onChange={(e) => setFontSizeCountry(Number(e.target.value))}
                        className="w-full h-2 bg-zinc-700 rounded-lg appearance-none cursor-pointer accent-pink-500"
                      />
                    </div>
                    <div>
                      <Label htmlFor="font-size-points" className="text-zinc-300 mb-2 block">Puntos ({fontSizePoints}px)</Label>
                      <input
                        type="range"
                        id="font-size-points"
                        data-testid="slider-font-size-points"
                        min="14"
                        max="48"
                        value={fontSizePoints}
                        onChange={(e) => setFontSizePoints(Number(e.target.value))}
                        className="w-full h-2 bg-zinc-700 rounded-lg appearance-none cursor-pointer accent-pink-500"
                      />
                    </div>
                    <div>
                      <Label htmlFor="font-size-voting" className="text-zinc-300 mb-2 block">Columna Votación ({fontSizeVoting}px)</Label>
                      <input
                        type="range"
                        id="font-size-voting"
                        data-testid="slider-font-size-voting"
                        min="12"
                        max="36"
                        value={fontSizeVoting}
                        onChange={(e) => setFontSizeVoting(Number(e.target.value))}
                        className="w-full h-2 bg-zinc-700 rounded-lg appearance-none cursor-pointer accent-pink-500"
                      />
                    </div>
                  </div>
                </div>

                {/* Colores de Filas del Leaderboard */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Colores de Filas</Label>
                  <p className="text-zinc-500 text-sm mb-4">Personaliza el color de fondo de las filas del leaderboard</p>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <Label htmlFor="row-bg-even" className="text-zinc-300 mb-2 block font-semibold">Filas Pares</Label>
                      <div className="flex gap-2">
                        <input
                          type="color"
                          data-testid="picker-row-bg-even"
                          value={toPickerHex(rowBgEven)}
                          onChange={(e) => setRowBgEven(e.target.value)}
                          className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                        />
                        <Input
                          id="row-bg-even"
                          data-testid="input-row-bg-even"
                          value={rowBgEven}
                          onChange={(e) => setRowBgEven(e.target.value)}
                          className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                          placeholder="rgba(24, 24, 27, 0.9)"
                        />
                      </div>
                      <button
                        data-testid="btn-row-bg-even-translucent"
                        onClick={() => setRowBgEvenTranslucent(!rowBgEvenTranslucent)}
                        className={`mt-1 text-xs px-2 py-0.5 rounded border ${rowBgEvenTranslucent ? 'border-cyan-500/50 text-cyan-400 bg-cyan-950/30' : 'border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}
                      >{rowBgEvenTranslucent ? "Translúcido" : "Opaco"}</button>
                    </div>
                    <div>
                      <Label htmlFor="row-bg-odd" className="text-zinc-300 mb-2 block font-semibold">Filas Impares</Label>
                      <div className="flex gap-2">
                        <input
                          type="color"
                          data-testid="picker-row-bg-odd"
                          value={toPickerHex(rowBgOdd)}
                          onChange={(e) => setRowBgOdd(e.target.value)}
                          className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                        />
                        <Input
                          id="row-bg-odd"
                          data-testid="input-row-bg-odd"
                          value={rowBgOdd}
                          onChange={(e) => setRowBgOdd(e.target.value)}
                          className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                          placeholder="rgba(39, 39, 42, 0.7)"
                        />
                      </div>
                      <button
                        data-testid="btn-row-bg-odd-translucent"
                        onClick={() => setRowBgOddTranslucent(!rowBgOddTranslucent)}
                        className={`mt-1 text-xs px-2 py-0.5 rounded border ${rowBgOddTranslucent ? 'border-cyan-500/50 text-cyan-400 bg-cyan-950/30' : 'border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}
                      >{rowBgOddTranslucent ? "Translúcido" : "Opaco"}</button>
                    </div>
                  </div>
                  
                  {/* Preview of row colors */}
                  <div className="mt-4 space-y-1">
                    <p className="text-zinc-400 text-sm mb-2">Vista previa:</p>
                    <div className="p-2 rounded" style={{ backgroundColor: rowBgEvenTranslucent ? toPickerHex(rowBgEven) + '40' : rowBgEven }}>
                      <span className="text-white text-sm">Fila Par (0, 2, 4...)</span>
                    </div>
                    <div className="p-2 rounded" style={{ backgroundColor: rowBgOddTranslucent ? toPickerHex(rowBgOdd) + '40' : rowBgOdd }}>
                      <span className="text-white text-sm">Fila Impar (1, 3, 5...)</span>
                    </div>
                  </div>

                  {/* Position number badge opacity for normal rows */}
                  <div className="mt-4 pt-3 border-t border-zinc-700 flex items-center justify-between">
                    <div>
                      <Label className="text-zinc-300 text-sm">Números de posición translúcidos</Label>
                      <p className="text-zinc-500 text-xs">El recuadro del número de las filas usa el color de su fila (Par/Impar) translúcido</p>
                    </div>
                    <button
                      type="button"
                      data-testid="toggle-row-badge-translucent"
                      onClick={() => setRowBadgeTranslucent(!rowBadgeTranslucent)}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors shrink-0 ${rowBadgeTranslucent ? 'bg-pink-600' : 'bg-zinc-700'}`}
                    >
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${rowBadgeTranslucent ? 'translate-x-6' : 'translate-x-1'}`} />
                    </button>
                  </div>
                </div>

                {/* Colores del Top 3 */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Colores del Top 3</Label>
                  <p className="text-zinc-500 text-sm mb-4">Colores personalizados para las 3 primeras posiciones durante la votación. Al terminar todas las votaciones, cambiarán automáticamente a dorado, plata y bronce.</p>
                  
                  <div className="grid md:grid-cols-3 gap-4">
                    <div>
                      <Label className="text-zinc-300 mb-2 block font-semibold">1er Puesto</Label>
                      <div className="flex gap-2">
                        <input
                          type="color"
                          data-testid="input-top1-color"
                          value={top1Color}
                          onChange={(e) => setTop1Color(e.target.value)}
                          className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                        />
                        <Input
                          value={top1Color}
                          onChange={(e) => setTop1Color(e.target.value)}
                          className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                        />
                      </div>
                      <button
                        onClick={() => setTop1Translucent(!top1Translucent)}
                        className={`mt-1 text-xs px-2 py-0.5 rounded border ${top1Translucent ? 'border-cyan-500/50 text-cyan-400 bg-cyan-950/30' : 'border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}
                      >{top1Translucent ? "Translúcido" : "Opaco"}</button>
                    </div>
                    <div>
                      <Label className="text-zinc-300 mb-2 block font-semibold">2do Puesto</Label>
                      <div className="flex gap-2">
                        <input
                          type="color"
                          data-testid="input-top2-color"
                          value={top2Color}
                          onChange={(e) => setTop2Color(e.target.value)}
                          className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                        />
                        <Input
                          value={top2Color}
                          onChange={(e) => setTop2Color(e.target.value)}
                          className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                        />
                      </div>
                      <button
                        onClick={() => setTop2Translucent(!top2Translucent)}
                        className={`mt-1 text-xs px-2 py-0.5 rounded border ${top2Translucent ? 'border-cyan-500/50 text-cyan-400 bg-cyan-950/30' : 'border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}
                      >{top2Translucent ? "Translúcido" : "Opaco"}</button>
                    </div>
                    <div>
                      <Label className="text-zinc-300 mb-2 block font-semibold">3er Puesto</Label>
                      <div className="flex gap-2">
                        <input
                          type="color"
                          data-testid="input-top3-color"
                          value={top3Color}
                          onChange={(e) => setTop3Color(e.target.value)}
                          className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                        />
                        <Input
                          value={top3Color}
                          onChange={(e) => setTop3Color(e.target.value)}
                          className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                        />
                      </div>
                      <button
                        onClick={() => setTop3Translucent(!top3Translucent)}
                        className={`mt-1 text-xs px-2 py-0.5 rounded border ${top3Translucent ? 'border-cyan-500/50 text-cyan-400 bg-cyan-950/30' : 'border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}
                      >{top3Translucent ? "Translúcido" : "Opaco"}</button>
                    </div>
                  </div>

                  {/* Last place color */}
                  <div className="mt-4">
                    <Label className="text-zinc-300 mb-2 block font-semibold">Ultimo Puesto</Label>
                    <div className="flex gap-2 max-w-xs">
                      <input
                        type="color"
                        data-testid="input-last-place-color"
                        value={lastPlaceColor}
                        onChange={(e) => setLastPlaceColor(e.target.value)}
                        className="w-16 h-10 rounded cursor-pointer border border-zinc-700"
                      />
                      <Input
                        value={lastPlaceColor}
                        onChange={(e) => setLastPlaceColor(e.target.value)}
                        className="flex-1 bg-zinc-800 border-zinc-700 text-white"
                      />
                    </div>
                    <button
                      onClick={() => setLastPlaceTranslucent(!lastPlaceTranslucent)}
                      className={`mt-1 text-xs px-2 py-0.5 rounded border ${lastPlaceTranslucent ? 'border-cyan-500/50 text-cyan-400 bg-cyan-950/30' : 'border-zinc-700 text-zinc-500 hover:text-zinc-300'}`}
                    >{lastPlaceTranslucent ? "Translúcido" : "Opaco"}</button>
                  </div>
                  
                  {/* Preview */}
                  <div className="mt-4 space-y-1">
                    <p className="text-zinc-400 text-sm mb-2">Vista previa (durante votación):</p>
                    <div className="flex gap-2">
                      <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm" style={{ backgroundColor: top1Color }}>1</div>
                      <div className="flex-1 p-2 rounded-lg" style={{ backgroundColor: top1Color + '40' }}>
                        <span className="text-white text-sm">Primer Puesto</span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm" style={{ backgroundColor: top2Color }}>2</div>
                      <div className="flex-1 p-2 rounded-lg" style={{ backgroundColor: top2Color + '40' }}>
                        <span className="text-white text-sm">Segundo Puesto</span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm" style={{ backgroundColor: top3Color }}>3</div>
                      <div className="flex-1 p-2 rounded-lg" style={{ backgroundColor: top3Color + '40' }}>
                        <span className="text-white text-sm">Tercer Puesto</span>
                      </div>
                    </div>
                    <div className="flex gap-2 mt-2 pt-2 border-t border-zinc-700">
                      <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-xs" style={{ backgroundColor: lastPlaceColor }}>N</div>
                      <div className="flex-1 p-2 rounded-lg" style={{ backgroundColor: lastPlaceColor }}>
                        <span className="text-white text-sm">Ultimo Puesto</span>
                      </div>
                    </div>
                  </div>

                  {/* Position number badge opacity */}
                  <div className="mt-4 pt-3 border-t border-zinc-700 flex items-center justify-between">
                    <div>
                      <Label className="text-zinc-300 text-sm">Números de posición translúcidos</Label>
                      <p className="text-zinc-500 text-xs">Aplica transparencia al recuadro del número (Top y último puesto)</p>
                    </div>
                    <button
                      type="button"
                      data-testid="toggle-position-badge-translucent"
                      onClick={() => setPositionBadgeTranslucent(!positionBadgeTranslucent)}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors shrink-0 ${positionBadgeTranslucent ? 'bg-pink-600' : 'bg-zinc-700'}`}
                    >
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${positionBadgeTranslucent ? 'translate-x-6' : 'translate-x-1'}`} />
                    </button>
                  </div>
                </div>
    </>
  );
};
